import { select, call, put } from "redux-saga/effects";
import { deconstructSchoolID } from "lib/appserver/aggregate";
import RemoteServerCompleteFailureError from "lib/appserver/responseExceptions/RemoteServerCompleteFailureError";

import { sendSchoolMoneyDataRequest } from "state/fetchSagas";

import {
  getCheckoutTransactionID,
  getCheckoutSchoolID
} from "state/school_money/selectors";
import { setCheckoutError, completeCheckout } from "state/school_money/actions";

export default function* confirmTransactionSaga(action) {
  
  const { paysafeSingleUseToken, cardholderName } = action.payload;
  const transactionID = yield select(getCheckoutTransactionID);
  
  const schoolID = yield select(getCheckoutSchoolID);
  const { serverID, remoteSchoolID } = deconstructSchoolID(schoolID);
  
  try {
    yield call(sendSchoolMoneyDataRequest, "confirm_transaction", {
      server_id: serverID,
      remote_school_id: remoteSchoolID,
      transaction_id: transactionID,
      single_use_token: paysafeSingleUseToken,
      cardholder_name: cardholderName
    });
  } catch (error) {
    // handle REMOTE_FAIL_COMPLETE
    if (error.type === RemoteServerCompleteFailureError.type) {
      yield put(setCheckoutError("ERROR_REMOTE_SERVER_FAIL"));
      return;
    } else {
      throw error;
    }
  }
  
  yield put(completeCheckout());
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/confirmTransactionSaga.js